import React from 'react';
import clsx from 'clsx';
export type TableCellAlign = 'left' | 'center' | 'right';

export interface TableCellProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLTableDataCellElement>,
    HTMLTableDataCellElement
  > {
  className?: string;
  /**
   * Горизонтальное выравнивание текста ячейки
   */
  align?: TableCellAlign;
}

export const TableCell: React.FC<TableCellProps> = ({
  children,
  className,
  align,
  ...props
}) => {
  return (
    <td
      className={clsx(
        'hse-Table__td',
        {
          [`hse-Table__td_align_${align}`]: align
        },
        className
      )}
      {...props}
    >
      {children}
    </td>
  );
};
